import React from 'react';
import styled from 'styled-components';

import customHistory from '../../../customHistory';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const StyledTitle = styled.h1`
  margin: 0;
  color: #3568d5;
  font-size: 18rem;
  line-height: 1;
`;

const StyledMessage = styled.span`
  font-size: 2rem;
  font-weight: 700;
  color: #33373c;
  margin: 4rem 0;
`;

const StyledGoBackLink = styled.span`
  font-weight: 700;
  color: #3568d5;
  cursor: pointer;
`;

const NotFoundPage = () => (
  <StyledContainer>
    <StyledTitle>404</StyledTitle>
    <StyledMessage>Oops! We couldn't find the page you are looking for.</StyledMessage>
    <StyledGoBackLink onClick={customHistory.goBack}>Go back</StyledGoBackLink>
  </StyledContainer>
);

export { NotFoundPage };
